module.exports = __webpack_public_path__ + "static/img/no5.c748647d.png";